// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.play-button_play-button_S6y94 {
    display: flex;
    align-items: center;
    justify-content: center;

    overflow: hidden;  /* Mask the icon animation */
    width: 2.5rem;
    height: 2.5rem;
    background-color: var(--sound-primary);
    color: var(--ui-white);
    border-radius: 50%;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    -webkit-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    cursor: pointer;
    transition: all 0.15s ease-out;
}

.play-button_play-button_S6y94 {
    position: absolute;
    top: .5rem;
    z-index: auto;
}

.play-button_play-button_S6y94:focus {
    outline: none;
}

.play-button_play-icon_SrDY9 {
  width: 50%;
}

[dir="ltr"] .play-button_play-button_S6y94 {
    right: .5rem;
}

[dir="rtl"] .play-button_play-button_S6y94 {
    left: .5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/play-button/play-button.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,gBAAgB,GAAG,4BAA4B;IAC/C,aAAa;IACb,cAAc;IACd,sCAAsC;IACtC,sBAAsB;IACtB,kBAAkB;IAClB,2DAA2D;IAC3D,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB;IACzB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.play-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    overflow: hidden;  /* Mask the icon animation */\n    width: 2.5rem;\n    height: 2.5rem;\n    background-color: var(--sound-primary);\n    color: var(--ui-white);\n    border-radius: 50%;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n    transition: all 0.15s ease-out;\n}\n\n.play-button {\n    position: absolute;\n    top: .5rem;\n    z-index: auto;\n}\n\n.play-button:focus {\n    outline: none;\n}\n\n.play-icon {\n  width: 50%;\n}\n\n[dir=\"ltr\"] .play-button {\n    right: .5rem;\n}\n\n[dir=\"rtl\"] .play-button {\n    left: .5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"play-button": `play-button_play-button_S6y94`,
	"playButton": `play-button_play-button_S6y94`,
	"play-icon": `play-button_play-icon_SrDY9`,
	"playIcon": `play-button_play-icon_SrDY9`
};
export default ___CSS_LOADER_EXPORT___;
